export default __webpack_public_path__ + "static/media/Group 10431.ca4796ca.svg";